import React, { Fragment } from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import Label from './Label';
import BetweenLabel from './BetweenLabel';

import { AppState } from '../../../appredux';

import { connect } from 'react-redux';

export interface MenuItemProps {
    value: string | number,
    text: string | number,
    disabled?: boolean
}

export interface MuiSelectProps {
    key: string | number,
    value: string | number,
    data: Array<MenuItemProps>,
    onChange: (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
    }>, child: React.ReactNode) => void,
    dirtyBackground?: string,
    formControlStyle?: React.CSSProperties,
    label?: string,
    betweenLabel?: string,
    labelSecondary?: boolean,
    labelBold?: boolean,
    labelBlock?: boolean,
    labelStyle?: React.CSSProperties,
    labelClasses?: string,
    required?: boolean,
    style?: React.CSSProperties,
    className?: string,
    disabled?: boolean,
}

interface MuiSelectState {
    selected: boolean
}

class MuiSelect extends React.Component<MuiSelectProps & WithStyles<typeof styles>, MuiSelectState> {

    constructor(props: MuiSelectProps & WithStyles<typeof styles>) {
        super(props);
        this.state = { selected: false };
    }

    onMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        if (!this.state.selected)
            this.setState({ selected: true });
    }

    select = () => {
        const classes = this.props.classes;

        return (
            <Select
                value={this.props.value} onChange={this.props.onChange}
                style={
                    this.state.selected
                        ? {
                            ...this.props.style,
                            backgroundColor: this.props.dirtyBackground
                        }
                        : this.props.style
                }
                className={this.props.className}
                classes={{ selectMenu: classes.left }}
                input={<OutlinedInput labelWidth={0} />}
                disabled={this.props.disabled}
            >
                {this.props.data.map((d: MenuItemProps) => (
                    <MenuItem
                        key={d.value} value={d.value}
                        disabled={d.disabled} onClick={this.onMenuItemClick}
                    >
                        {d.text}
                    </MenuItem>
                ))}
            </Select>
        )
    }

    render() {
        const classes = this.props.classes;

        return (
            <Fragment>
                <FormControl
                    variant="outlined" margin="normal" fullWidth
                    className={classes.formControl}
                    style={this.props.formControlStyle}
                >
                    {this.props.betweenLabel ?
                        <BetweenLabel
                            label={this.props.betweenLabel}
                            secondary={this.props.labelSecondary}
                        />
                        :
                        <Label
                            label={this.props.label}
                            secondary={this.props.labelSecondary}
                            bold={this.props.labelBold}
                            block={this.props.labelBlock}
                            style={this.props.labelStyle}
                            className={this.props.labelClasses}
                            required={this.props.required}
                        />
                    }
                    {this.select()}
                </FormControl>
            </Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    formControl: {
        display: "block",
        //paddingBottom: "35px"
    },
    left: {
        textAlign: "left" as "left"
    },
});

const mapStateToProps = (state: AppState) => ({
    dirtyBackground: state.pageState.secondaryLight
});

export default connect(mapStateToProps)(withStyles(styles)(MuiSelect));